import ACTUALIZAR_CONTRATO_CATALOGO_CONCEPTO from '@/graphql/mutations/administracion/contratos/contrato/catalogo/actualizarContratoCatalogoConcepto.gql';
import CONTRATO_CATALOGO_CONCEPTOS from '@/graphql/querys/administracion/contratos/catalogoConceptos/contratoCatalogoConceptos.gql';
import REMOVER_CONTRATO_CATALOGO_CONCEPTO from '@/graphql/mutations/administracion/contratos/contrato/catalogo/removerContratoCatalogoConcepto.gql';
import AGREGAR_CONTRATO_CATALOGO_CONCEPTO from '@/graphql/mutations/administracion/contratos/contrato/catalogo/agregarContratoCatalogoConcepto.gql';
import MARCAR_CONCEPTO_FAVORITO from '@/graphql/mutations/administracion/contratos/contrato/catalogo/marcarFavoritoCatalogoConcepto.gql';

export default {
  apollo: {
    contratoCatalogoConceptos: {
      query: CONTRATO_CATALOGO_CONCEPTOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    setOrden() {
      if (this.tipoConcepto.tipo === 0) {
        const numPartidas = this.contratoCatalogoConceptos
          .filter((conceptos) => conceptos.tipo < 1)
          .length;
        const ordenPartida = (numPartidas + 1) * 100000;
        this.concepto.orden = ordenPartida;
      }
      if (this.tipoConcepto.tipo === 1) {
        // const numSubpartidas = this.contratoCatalogoConceptos
        //   .filter((subPartidas) => subPartidas.tipo
        //   === 1
        //   && subPartidas.orden > this.tipoConcepto.orden
        //   && subPartidas.orden < (this.tipoConcepto.orden + 100000))
        //   .length;
        // const partidas = this.contratoCatalogoConceptos
        //   .filter(({ tipo }) => tipo === 1)
        //   .filter(({ idPadre }) => idPadre === this.tipoConcepto.idPadre);
        // this.concepto.orden = (this.tipoConcepto.orden) + 1;
      }
      if (this.tipoConcepto.tipo === 2) {
        const partidas = this.contratoCatalogoConceptos
          .filter(({ tipo }) => tipo === 2)
          .filter(({ idPadre }) => idPadre === this.tipoConcepto.idPadre);
        this.concepto.orden = (this.tipoConcepto.orden + (partidas.length + 1));
      }
    },
    async mixAgregarCatalogoConcepto() {
      // this.setOrden();
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_CATALOGO_CONCEPTO,
          variables: {
            concepto: this.concepto,
          },
          update: (store, { data: { agregarContratoCatalogoConcepto } }) => {
            const query = {
              query: CONTRATO_CATALOGO_CONCEPTOS,
              variables: {
                idContrato: this.tipoConcepto.idContrato,
              },
            };
            const { contratoCatalogoConceptos } = store.readQuery(query);
            const contratoCatalogoConceptosCopia = contratoCatalogoConceptos.slice();
            contratoCatalogoConceptosCopia.push(agregarContratoCatalogoConcepto);
            store.writeQuery({
              ...query,
              data: {
                contratoCatalogoConceptos: contratoCatalogoConceptosCopia,
              },
            });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarCatalogoConcepto() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_CATALOGO_CONCEPTO,
          variables: {
            id: this.catalogoConceptoEditar.id,
            concepto: this.concepto,
          },
          update: (store, { data: { actualizarContratoCatalogoConcepto } }) => {
            const query = {
              query: CONTRATO_CATALOGO_CONCEPTOS,
              variables: {
                idContrato: this.catalogoConceptoEditar.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoCatalogoConceptos } = data;
            const index = contratoCatalogoConceptos
              .findIndex((concepto) => concepto.id
              === actualizarContratoCatalogoConcepto.id);
            if (index !== -1) {
              contratoCatalogoConceptos.splice(index, 1, actualizarContratoCatalogoConcepto);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarCatalogoConcepto() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_CATALOGO_CONCEPTO,
        variables: {
          id: this.catalogoConceptoEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_CATALOGO_CONCEPTOS,
            variables: {
              idContrato: this.catalogoConceptoEliminar.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoCatalogoConceptos } = data;
          const index = contratoCatalogoConceptos
            .findIndex((concepto) => concepto.id === this.catalogoConceptoEliminar.id);
          if (index !== -1) {
            contratoCatalogoConceptos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixMarcarComoFavorito() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: MARCAR_CONCEPTO_FAVORITO,
          variables: {
            id: this.id,
            esFavorito: !this.esFavorito,
          },
          update: (store, { data: { marcarFavoritoCatalogoConcepto } }) => {
            const query = {
              query: CONTRATO_CATALOGO_CONCEPTOS,
              variables: {
                idContrato: this.$route.params.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoCatalogoConceptos } = data;
            const index = contratoCatalogoConceptos
              .findIndex((concepto) => concepto.id
              === marcarFavoritoCatalogoConcepto.id);
            if (index !== -1) {
              contratoCatalogoConceptos.splice(index, 1, marcarFavoritoCatalogoConcepto);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
  },
};
